import React from "react";
import { PageHero, SectionHeading } from "../components/Sections";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { EnquiryDialog } from "../components/LeadForm";
import { Icon } from "../components/icons";
import { whyChooseUs } from "../mock/data";
import { Target, Eye, Handshake, CheckCircle2 } from "lucide-react";

const values = [
  { icon: Target, title: "Our Mission", desc: "To help Indians access suitable financial products transparently and responsibly." },
  { icon: Eye, title: "Our Vision", desc: "To make India financially healthy, strong and safe — by helping each other grow." },
  { icon: Handshake, title: "Our Promise", desc: "Clear communication, need-based data collection and no misleading claims." },
];

export default function About() {
  return (
    <div>
      <PageHero
        title="About Loansupportindia"
        subtitle="Built for Indians to make India financially healthy, strong and safe. We help each other to make our nation stronger."
        crumbs={[{ label: "About Us" }]}
      />

      <section className="section-pad">
        <div className="container-page grid gap-12 lg:grid-cols-2 lg:items-center">
          <div className="relative">
            <img src="https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"
              alt="Our finance team" className="rounded-2xl shadow-xl w-full object-cover aspect-[4/3]" />
          </div>
          <div>
            <SectionHeading center={false} eyebrow="Who We Are"
              title="A facilitation platform, not the lender"
              desc="Loansupportindia is a digital marketplace that helps you find and apply for suitable loan, insurance and credit products from authorised partners." />
            <p className="text-muted-foreground">
              We clearly distinguish our role as a facilitator/lead generator from the role of banks and NBFCs, who are
              the actual lenders. Loan approval, interest rate, tenure and other terms are determined by the respective
              lender, subject to its eligibility and underwriting policies.
            </p>
            <ul className="mt-5 space-y-2.5">
              {["Transparent business model", "Explicit consent before sharing data", "Clear grievance redressal", "Compliant, non-misleading communication"].map((t) => (
                <li key={t} className="flex items-center gap-2.5 text-sm">
                  <CheckCircle2 className="h-4 w-4 text-primary" /> {t}
                </li>
              ))}
            </ul>
            <div className="mt-7">
              <EnquiryDialog trigger={<Button size="lg">Get in touch</Button>} />
            </div>
          </div>
        </div>
      </section>

      <section className="section-pad bg-secondary/40">
        <div className="container-page">
          <SectionHeading eyebrow="What Drives Us" title="Our mission, vision & promise" />
          <div className="grid gap-6 md:grid-cols-3">
            {values.map((v) => (
              <Card key={v.title} className="border p-6">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-primary-foreground">
                  <v.icon className="h-6 w-6" />
                </div>
                <h3 className="mt-4 font-heading text-lg font-semibold">{v.title}</h3>
                <p className="mt-1.5 text-sm text-muted-foreground">{v.desc}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="section-pad">
        <div className="container-page">
          <SectionHeading eyebrow="Why Choose Us" title="Efficiency, responsibility and support" />
          <div className="grid gap-6 md:grid-cols-3">
            {whyChooseUs.map((w) => (
              <Card key={w.no} className="border p-6 text-center">
                <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-secondary text-primary">
                  <Icon name={w.icon} className="h-6 w-6" />
                </div>
                <h3 className="mt-3 font-heading text-lg font-semibold">{w.title}</h3>
                <p className="mt-1.5 text-sm text-muted-foreground">{w.desc}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
